import getValueOffPercent from 'lib/offer/getValueOffPercent'
import { SavedHotelData } from 'tripPlanner/types/tripItem'
import {
  CreateHotelRequestBody,
  formatTimeForPayload,
  getLeHotelCheckInAndOutTimes,
  getPlaceFromOffer,
} from 'tripPlanner/utils/itemConversions/common'

interface Params {
  offer: App.Offer
  pkg: App.Package
  startDate: string
  endDate: string
  occupancies: Array<App.Occupants>
  currentRegionCode: string
  currencyCode: string
  /** This should be the _total_ price (including taxes etc.) */
  price: number
  value: number
}

export function createLEHotelItemPayload({
  offer,
  pkg,
  startDate,
  endDate,
  occupancies,
  currentRegionCode,
  currencyCode,
  price,
  value,
}: Params): CreateHotelRequestBody {
  if (
    offer.type === 'tour' ||
    offer.type === 'bundle_and_save' ||
    offer.type === 'rental'
  ) {
    // Just to satisfy Typescript. This shouldn't ever happen.
    throw new Error('Invalid offer type')
  }

  const rateId = pkg.roomRate?.id
  const hotelBookingExtraData: SavedHotelData = {
    offerType: offer.type,
    regionCode: currentRegionCode,
    currencyCode,
    offerId: offer.id,
    packageId: pkg.id,
    checkIn: startDate,
    checkOut: endDate,
    rateId,
    occupancies,
    price,
    value,
    roomTypeId: pkg.roomType?.id,
    discountPercent: getValueOffPercent(value, price),
    priceDisplayType: 'taxesAndFeesInclusive',
    roomTypeName: pkg.roomType?.name,
  }

  const [startTimeMoment, endTimeMoment] = getLeHotelCheckInAndOutTimes(offer)

  const payload: CreateHotelRequestBody = {
    type: 'HOTEL',
    isBooked: false,
    sourceType: 'LE_Hotel',
    startDate,
    endDate,
    startTime: formatTimeForPayload(startTimeMoment),
    endTime: formatTimeForPayload(endTimeMoment),
    place: getPlaceFromOffer(offer),
    code: offer.id,
    subCode: pkg.roomType?.id,
    savedItemData: hotelBookingExtraData,
  }

  return payload
}
